export function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className="footer-container">
            <span>&copy; {year} - Case Tecnologia</span>
        </footer>
    );
}
